import { Appender } from "./Appender";
import { LoggingLevel } from "./LoggingLevel";
import { LoggingEvent } from "./LoggingEvent";

/**
 * Логгер.
 * Ответственен за создание лог событий и передачу их обработчикам.
 */
export class Logger {
  private readonly name: string;

  private readonly appenders: Appender[] = [];

  private loggingLevel: LoggingLevel;

  constructor(name: string, appenders: Appender[], loggingLevel: LoggingLevel) {
    this.name = name;
    this.appenders = appenders;
    this.loggingLevel = loggingLevel;
  }

  /**
   * Получить имя логгера.
   */
  getName() {
    return this.name;
  }

  /**
   * Установить уровень логирования.
   * @param level - уровень логирования.
   */
  setLoggingLevel(level: LoggingLevel) {
    this.loggingLevel = level;
    return this;
  }

  /**
   * TRACE событие.
   */
  trace(message: string, error?: Error) {
    this.log(LoggingLevel.TRACE, message, error);
  }

  /**
   * DEBUG событие.
   */
  debug(message: string, error?: Error) {
    this.log(LoggingLevel.DEBUG, message, error);
  }

  /**
   * INFO событие.
   */
  info(message: string, error?: Error) {
    this.log(LoggingLevel.INFO, message, error);
  }

  /**
   * WARN событие.
   */
  warn(message: string, error?: Error) {
    this.log(LoggingLevel.WARN, message, error);
  }

  /**
   * ERROR событие.
   */
  error(message: string, error?: Error) {
    this.log(LoggingLevel.ERROR, message, error);
  }

  private log(level: LoggingLevel, message: string, error?: Error) {
    if (level >= this.loggingLevel) {
      const loggingEvent = new LoggingEvent(
        this.name,
        level,
        message,
        error?.stack
      );

      this.callAppenders(loggingEvent);
    }
  }

  private callAppenders(action: LoggingEvent) {
    this.appenders.forEach((appender) => appender.doAppend(action));
  }
}
